import React from 'react';
import { useAppContext as useAppContextNew } from './AppContext';
import { useDataContext as useDataContextNew } from './DataContext';
import { AppContextProvider } from './AppContext';
import { DataContextProvider } from './DataContext';

// Backward compatibility layer - re-export the new contexts
export { useAppContext as useAppContextOld } from './AppContext';
export { useDataContext as useDataContextOld } from './DataContext';
export { AppContextProvider, type SnackbarType } from './AppContext';
export { DataContextProvider, type AutocompleteType } from './DataContext';

// Combined hook for backward compatibility

export const useAppContext = () => {
  const appContext = useAppContextNew();
  const dataContext = useDataContextNew();

  return {
    ...appContext,
    ...dataContext
  };
};

// Legacy ContextProvider for backward compatibility (deprecated)

export const ContextProvider = ({ children }: { children: React.ReactNode }) => {
  console.warn('ContextProvider is deprecated. Use AppContextProvider and DataContextProvider separately.');
  return (
    <AppContextProvider>
      <DataContextProvider>{children}</DataContextProvider>
    </AppContextProvider>
  );
};
